export default "__VITE_ASSET__CE7P3mSJ__"